import get from 'lodash/get'
import dayjs from 'dayjs'
import { importComponents } from '~/helpers'
import Store from '~/store'

export default {
    components: {
        ...importComponents(require.context('components/common')),
        ...importComponents(require.context('components/common/company')),
        ...importComponents(require.context('components/common/page')),
        ...importComponents(require.context('components/common/user')),
    },

    methods: {
        $get(object, path, defaultValue) {
            return get(object, path, defaultValue)
        },

        $startLoader() {
            Store.dispatch('configuration/setIsLoading', true)
        },

        $stopLoader() {
            Store.dispatch('configuration/setIsLoading', false)
        },

        emitEvent({ name, payload }, ignoredEvents = []) {
            if (ignoredEvents.includes(name)) {
                return
            }
            this.$emit(name, payload)
            this.$emit('emitEvent', { name, payload })
        },

        isDescendant(child, parent) {
            let node = child.parentNode

            while (node !== null) {
                if (node === parent) {
                    return true
                }

                node = node.parentNode
            }

            return false
        },
    },

    filters: {
        dayjs(date, format) {
            return dayjs(date).format(format)
        },
    },
}
